import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { toggleFilter } from 'src/app/store/navigation';
import { APP_CONFIG } from 'src/app/app.config';
import {map} from "rxjs/operators";
import {Observable} from "rxjs";
import {AuthorizeService} from "../../../../api-authorization/authorize.service";

@Component({
  selector: 'smart-nav-info-card',
  templateUrl: './nav-info-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavInfoCardComponent {

  public user: Observable<string>;
  avatar = APP_CONFIG.avatar;

  constructor(private store: Store<any>, private authorizeService: AuthorizeService) { }

  ngOnInit() {
    this.user = this.authorizeService.getUser().pipe(map(u => u && u.name));
  }

  toggleFilter($event: MouseEvent) {
    $event.preventDefault();
    this.store.dispatch(toggleFilter());

  }
}
